<script setup lang="ts">
import Footer from './code/Footer.vue';
import Header from './code/Header.vue';

import '../styles/code-layout.scss';
</script>

<template>
  <div class="code-layout">
    <Header class="" />
    <RouterView class="content-layout" />
    <Footer class="footer-layout" />
  </div>
</template>
